import { Volume2, VolumeX } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Slider } from "../Slider";

interface PlayerVolumeProps {
  volume: number;
  onVolumeChange: (value: number) => void;
}

export const PlayerVolume: React.FC<PlayerVolumeProps> = ({ volume, onVolumeChange }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [localVolume, setLocalVolume] = useState(volume);

  useEffect(() => {
    setLocalVolume(volume);
  }, [volume]);

  const handleVolumeChange = (newVolume: number) => {
    const roundedVolume = Math.round(newVolume * 100) / 100;
    setLocalVolume(roundedVolume);
    onVolumeChange(roundedVolume);
  };

  return (
    <div className="hidden md:flex items-center gap-2 w-full max-w-[120px]">
      <button
        onClick={() => onVolumeChange(volume === 0 ? 1 : 0)}
        className="p-1 sm:p-2 text-zinc-400 hover:text-white transition"
      >
        {volume === 0 ? <VolumeX className="w-4 h-4 sm:w-5 sm:h-5" /> : <Volume2 className="w-4 h-4 sm:w-5 sm:h-5" />}
      </button>
      <div className="relative flex-1 h-8">
        <Slider
          min={0}
          max={1}
          step={0.01}
          value={localVolume}
          onChange={handleVolumeChange}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          className="w-full"
        />
        {showTooltip && (
          <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-zinc-800 text-white px-2 py-1 rounded text-xs">
            {Math.round(localVolume * 100)}%
          </div>
        )}
      </div>
    </div>
  );
};
